export function getFileSizeString(sizeInBytes, fractions = 2) {
  if (!sizeInBytes) {
    return '0 B';
  }
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
  return (sizeInBytes / Math.pow(k, i)).toFixed(fractions) + ' ' + sizes[i];
}

export async function copyToClipboard(value) {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(value);
  } else {
    const elem = document.createElement('input');
    elem.value = value;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
  }
}
